import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 4h3a2 2 0 0 1 2 2v6a1 1 0 0 0 1 1h6a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-6a8 8 0 0 1 -8 -8v-6a2 2 0 0 1 2 -2","key":"svg-0"}]]

/**
 * IconJoinRound
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItam9pbi1yb3VuZCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNiA0aDNhMiAyIDAgMCAxIDIgMnY2YTEgMSAwIDAgMCAxIDFoNmEyIDIgMCAwIDEgMiAydjNhMiAyIDAgMCAxIC0yIDJoLTZhOCA4IDAgMCAxIC04IC04di02YTIgMiAwIDAgMSAyIC0yIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/join-round
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconJoinRound = createReactComponent('outline', 'join-round', 'JoinRound', __iconNode);

export default IconJoinRound;